module.exports = "ul.clients li {\r\n  color: #000acb;\r\n  cursor: pointer;\r\n}\r\n\r\nul.clients li.selected {\r\n  background-color : #cccccc;\r\n}\r\n"